export default __webpack_public_path__ + "static/media/talent_banner.11e1580b.svg";